import script from "./TeamSection.vue?vue&type=script&setup=true&lang=js"
export * from "./TeamSection.vue?vue&type=script&setup=true&lang=js"

import "./TeamSection.vue?vue&type=style&index=0&id=655060fe&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-655060fe"]])

export default __exports__